import { useField } from "formik";

import FileUpload from "./FileUpload";

const FormikFileUpload = ({ name, ...props }) => {
  const [_, { value, touched, error }, { setValue, setTouched, setError }] =
    useField(name);

  const errorToDisplay = touched && error ? error : "";

  return (
    <FileUpload
      {...{ ...props, setError, setTouched }}
      error={errorToDisplay}
      files={value}
      onChange={setValue}
    />
  );
};

export default FormikFileUpload;
